/**
 *  * Phase 1 – Super Admin frontend auth helpers
  * - Check access_token (not refresh_token)
   * - Validate token is not expired before considering user authenticated
    * - clearSession helper for interceptor-driven logout
     */

     const isTokenExpired = (token: string): boolean => {
       try {
           const payload = JSON.parse(atob(token.split('.')[1]))
               if (!payload.exp) return false // no expiry claim → treat as valid
                   return payload.exp * 1000 < Date.now()
                     } catch {
                         return true // malformed token → treat as expired
                           }
                           }

                           export const isAuthenticated = (): boolean => {
                             const accessToken = localStorage.getItem('access_token')
                               if (!accessToken) return false
                                 return !isTokenExpired(accessToken)
                                 }

                                 export const clearSession = (): void => {
                                   localStorage.removeItem('access_token')
                                     localStorage.removeItem('refresh_token')
                                     localStorage.removeItem('admin_role')
                                     }

// 'report-viewer' (marketing) may only open Reports. Only decides what the UI
// shows — the backend enforces access per endpoint. Sessions from before roles
// existed have no stored role and were super-admin logins.
export type AdminRole = 'super-admin' | 'report-viewer'

export const getAdminRole = (): AdminRole =>
  localStorage.getItem('admin_role') === 'report-viewer' ? 'report-viewer' : 'super-admin'
